export const RANGE_ELEMENT_CONNECTIONS = 5000;
export const RANGE_BOARD_ELEMENT_DETAILS = 6000;
